export var PartnerStatus;
(function (PartnerStatus) {
    PartnerStatus["ONBOARDING"] = "ONBOARDING";
    PartnerStatus["NEW"] = "NEW";
    PartnerStatus["ACTIVE"] = "ACTIVE";
    PartnerStatus["NON_STRATEGIC"] = "NON_STRATEGIC";
    PartnerStatus["PHASING_OUT"] = "PHASING_OUT";
    PartnerStatus["INACTIVE"] = "INACTIVE";
})(PartnerStatus || (PartnerStatus = {}));
